import React from "react";

const style = {
  maxWidth: 800,
  textAlign: "justify",
  textJustify: "inter-word"
};

export default () => (
  <div className="mt4 pb5">
    <h1 className="tc f3 mb2">About DSA</h1>
    <p style={style} className="center f5">
      The Defence Space Administration was established by the National Assembly
      of the Federal Republic of Nigeria to: Develop and operate military Space
      Technologies; Support Nigerian Military operations both within and outside
      the country as well as Security Agencies responsible for internal
      security, through the use of satellite; Provide resilient and affordable
      Space and Cyberspace capabilities for the Nigerian Military, other
      Security and Law Enforcement Agencies;
    </p>

    <h1 className="tc mb2 f3 mt5">History of DSA</h1>
    <p style={style} className="center f5">
      In 2001, the Nigerian Space Policy and Programmes (NSPP) was approved. The
      NSPP clearly stated that there shall be a Defence Space Command which
      would facilitate and implement the Defence and security aspects of the
      National Space Policy and Programmes 2001 for the enhancement of national
      security and development. Pursuant to the provisions of the NSPP, the
      Defence Space Agency (now known as the Defence Space Administration (DSA)
      was established on 9 October 2014. The DSA Act 2016 was enacted by the 8th
      National Assembly and signed into law on 3 February 2017. DSA therefore
      harnesses space products and services to aid the Nigerian military and
      other security agencies in tackling the security challenges faced by the
      country. This is in recognition of space as a force multiplier. Nigeria as
      a responsible member of the international community intends to pursue its
      legitimate ambition in space for security, national development and
      peaceful purposes for the advancement of humanity. This is in line with
      the provisions of the United Nations Committee for the Peaceful Uses of
      Outer Space (UNCOPUOS).
    </p>

    <h1 className="tc mb2 f3 mt5">DSA Mission</h1>
    <p style={style} className="center f5">
      TO support the armed forces of Nigeria and other security agencies with
      relevant space products and solutions necessary for the conduct of
      opertations in peace and wartime in line with the national space policy
      and programme
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/about.js